import { getHosts } from '~/shared/utils/env/hosts'

export const useExternalHost = (): string => {
  const config = useRuntimeConfig()

  return getHosts({
    NUXT_PUBLIC_ENVIRONMENT_STAND: config.public.environmentStand,
  }).externalHost
}
